var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOkeanYs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.294,
    height: 25.266,
    viewBox: "0 0 25.294 25.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8",
    "data-name": "Raggruppa 8",
    transform: "translate(-144.846 -80.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1612",
    transform: "translate(158.259 83.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M424.027,145.537,416.815,156.1l-.463,11.477a12.647,12.647,0,0,0,7.675-22.042Z",
    transform: "translate(-416.352 -145.537)",
    fill: "#2b9cfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2",
    "data-name": "Raggruppa 2",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M424.027,145.537,416.815,156.1l-.463,11.477a12.647,12.647,0,0,0,7.675-22.042Z",
    transform: "translate(-416.352 -145.537)",
    fill: "#2b9cfb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "path1608",
    transform: "translate(144.846 80.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4",
    "data-name": "Raggruppa 4",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3",
    "data-name": "Tracciato 3",
    d: "M157.493,80.293a12.582,12.582,0,0,0-6.157,1.6l5.579,8.528-1.388,2.226L149.1,83.487a12.64,12.64,0,0,0,7.646,22.071l-.463-11.78L163.694,81.9A12.746,12.746,0,0,0,157.493,80.293Z",
    transform: "translate(-144.846 -80.293)",
    fill: "#2b9cfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_6",
    "data-name": "Raggruppa 6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5",
    "data-name": "Raggruppa 5",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M157.493,80.293a12.582,12.582,0,0,0-6.157,1.6l5.579,8.528-1.388,2.226L149.1,83.487a12.64,12.64,0,0,0,7.646,22.071l-.463-11.78L163.694,81.9A12.746,12.746,0,0,0,157.493,80.293Z",
    transform: "translate(-144.846 -80.293)",
    fill: "#2b9cfb"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkeanYs);
export default __webpack_public_path__ + "static/media/okeanYs.6413b1223dd2a3e500cb8556011b096c.svg";
export { ForwardRef as ReactComponent };